module.exports = __webpack_public_path__ + "static/img/tab1.5c83e242.png";